import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { LoadingDirective } from '@iupics-components/directives/loading.directive';
import { NumberAnimationDirective } from '@iupics-components/directives/number-animation.directive';
import { BadgeButtonClickEvent, BadgeButtonData } from './badge-button-data';

@Component({
  selector: 'iu-badge-button',
  templateUrl: './badge-button-ui.component.html',
  styleUrls: ['./badge-button-ui.component.scss'],
  standalone: true,
  imports: [LoadingDirective, NgClass, NumberAnimationDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class BadgeButtonUiComponent {
  readonly data = input.required<BadgeButtonData>();
  readonly clickEmitter = output<BadgeButtonClickEvent>();

  onClick(event: MouseEvent): void {
    if (this.data()?.action) {
      return this.data().action();
    }

    this.clickEmitter.emit({ component: this, event });
  }
}
